import { Children, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Container from './Container';
import LangBox from './LangBox';
import { itemsConvert, itemsEdit } from './Header';
import { sendEvent } from '../utils/analytics';

export const itemsOther = [
  // { href: '/faq', text: 'nav.faq' },
  { href: '/privacy-policy', text: 'nav.privacy-policy' },
  { href: '/terms', text: 'nav.terms' },
  { href: '/do-not-sell', text: 'nav.do-not-sell' },
  { href: '/contact', text: 'nav.contact' },
  { href: '/blog', text: 'nav.blog' },
];

const Footer = () => {
  const { t } = useTranslation('common');
  const { asPath , locale: currentLocale} = useRouter();

  return (
    <footer className="footer">
      <Container className="footer__container">
        <div className="footer__left">
          <FooterMenu title={t('nav.convert-pdf')}>
            {itemsConvert.map((item, i) => (
              !item.disabled && (
                <FooterMenuItem
                  key={i}
                  text={t(item.text)}
                  href={item.href}
                  active={item.href === asPath}
                />
              )
            ))}
          </FooterMenu>
          <FooterMenu title={t('nav.edit-pdf')}>
            {itemsEdit.map((item, i) => (
              !item.disabled && (
                <FooterMenuItem
                  key={i}
                  text={t(item.text)}
                  href={item.href}
                  active={item.href === asPath}
                />
              )
            ))}
          </FooterMenu>
        </div>
        <div className="footer__right">
          <FooterMenu>
            {itemsOther.map((item, i) => (
              !item.disabled && (
                <FooterMenuItem
                  key={i}
                  text={t(item.text)}
                  href={item.href.includes("blog") && currentLocale !== 'en' ? `/${currentLocale}${item.href}` : item.href}
                  active={item.href === asPath}
                  locale={false}
                />
              )
              )
            )
            }
          </FooterMenu>
          <FooterLangBox />
        </div>
      </Container>
    </footer>
  );
};

const FooterMenu = ({ title, children }) => (
  <nav
    className={classNames(
      'footer__menu',
      Children.count(children) > 3 && 'footer__menu--multi-column',
    )}
    aria-label={title}
  >
    {title && (
      <div className="footer__menu__title">
        {title}
      </div>
    )}
    <ul className="footer__menu__list" role="menubar">
      {children}
    </ul>
  </nav>
);

const FooterMenuItem = ({ text, href, active, locale }) => {
  const handleClick = useCallback(() => {
    sendEvent({
      category: 'footer',
      action: 'link-click',
      label: href,
    });
  }, [href]);

  return (
    <li
      className={classNames(
        'footer__menu__item',
        active && 'footer__menu__item--active',
      )}
      role="none"
    >
      <Link href={href} locale={locale}>
        <a
          className="footer__menu__link"
          role="menuitem"
          onClick={handleClick}
        >
          {text}
        </a>
      </Link>
    </li>
  );
};

// eslint-disable-next-line no-unused-vars
const FooterLangBox = () => (
  <LangBox className="footer__lang-box" />
);

FooterMenu.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

FooterMenuItem.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  active: PropTypes.bool,
  locale: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
};

export default Footer;
